module.exports = __webpack_public_path__ + "static/media/logo.5b14364b.svg";